import {
  ICardOption,
} from "apps/website/components/form/RadioButtons/RadioButtons.types";

export const MULTI_CAT_DISCOUNT_COUNT_TWO = 2;
export const MULTI_CAT_DISCOUNT_COUNT_THREE = 3;
export const MORE_THAN_FOUR_CATS_COUNT = 4;

export const CAT_COUNT_OPTIONS: ICardOption[] = [
  { value: "1", label: "1", component: "card", icon: "catProfileAdult", selectedIcon: "catProfileAdultSelected" },
  { value: "2", label: "2", component: "card", icon: "multiCat2Cats", selectedIcon: "multiCat2CatsSelected" },
  { value: "3", label: "3", component: "card", icon: "multiCat3Cats", selectedIcon: "multiCat3CatsSelected" },
  { value: "4+", label: "4+", component: "card", icon: "multiCat4Cats", selectedIcon: "multiCat4CatsSelected" },
];

export const PLACEHOLDER_MAP: Record<number, string> = {
  0: "placeholder1",
  1: "placeholder2",
  2: "placeholder3",
  3: "placeholder4",
};
